var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("CompassDialog", {
    attrs: {
      visible: _vm.showModal,
      size: "small",
      title: _vm.$t.__(
        "activities.listing.massActions.ActivitiesMassMarkAsDone.title"
      ),
      primaryAction: {
        label: _vm.$t.__("common.actions.confirm"),
        action: function() {
          return _vm.handleConfirm()
        },
        loading: _vm.isSubmitting
      },
      secondaryActions: [
        {
          label: _vm.$t.__("common.actions.cancel"),
          action: function() {
            _vm.$emit("close")
          }
        }
      ]
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      },
      closed: function($event) {
        return _vm.$emit("close")
      }
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function() {
          return [
            _c("CompassAlert", {
              attrs: {
                description: _vm.$t.__(
                  "activities.listing.massActions.ActivitiesMassMarkAsDone.infoAlert"
                ),
                showClose: false
              }
            }),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "typographies-paragraph-medium-regular" },
              [_vm._v(_vm._s(_vm.textContent))]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }